// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.customIndent[data-v-d52e4820] {\n  margin-left: -20px;\n}\n.tab.active[data-v-d52e4820] {\n  color: #fff !important;\n}\n.tab[data-v-d52e4820]:hover {\n  color: #53DC86;\n}\n", ""]);
// Exports
module.exports = exports;
